import { getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleTextInput from '../../components/ModuleTextInput';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';

const EditDataButton = (props) => {
    const fieldData = props.fieldData;
    const customisationVars = props.customisationVars;

    const clickHandler = () => {
        // console.log("DISRUPTOR FIELD CLICK HANDLER");
        props.openClassicCustomisationSubsetPopup(fieldData?.customFieldConfig?.dataLink, props.index ?? 0, 'Edit Data', props.forceModuleListUpdate);
    }

    return (
        <>
            <button
                className={`v2-module-button`}
                onClick={clickHandler}
            >
                {fieldData?.customFieldConfig?.customFieldLabel ?? 'Edit Data'}
            </button>

            {/* <div className='v2-module-field-label'>{fieldData?.customFieldConfig?.customFieldLabel ?? 'String'}</div>
            <ModuleTextInput
                value={getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)}
                fieldId={'string-field'}
                enabled={props.isEnabled}
                editable={true}
                onChange={
                    (fieldId, value) => {
                        WORKING_ON_NODE_DATA.fieldData = fieldData;
                        WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
                        updateCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
                        props?.forceUpdateComponent?.();
                    }
                }
            /> */}
        </>
    );
};

export default EditDataButton;
